import { useLocation, useMatches } from 'react-router-dom'

export default function useRouteData(): AppRouteOptions {
  const matches = useMatches()
  const { pathname } = useLocation()

  const data =
    matches
      .filter((match) => match.pathname === pathname)
      .filter((match) => Boolean(match.handle))
      .map((match) => match.handle)[0] || {}

  return data as AppRouteOptions
}
